import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import * as validators from 'utils/validators';
import Dialog from 'components/Dialog';
import DateTimeField from 'components/DateTimeField';
import ThemeGallery from 'components/ThemeGallery';
import { canUseFeature } from '../../../config/pricing';
import { GalleryTemplates } from '../../../config/template_gallery';

const DOC_TYPE_MAP = {
  quote: 'quote',
  proforma: 'proforma',
  draft_order: 'invoice',
  manual_invoice: 'invoice'
};

const DRAFT_RELEVANT_TYPES = ['invoice', 'quote', 'proforma'];

class DownloadDraftsDialog extends Dialog {

  getAllAvailableThemes() {
    let { user } = this.props;
    let userThemes = user.themes || [];
    let installedNames = new Set(userThemes.map(t => t.name));
    let galleryForDrafts = GalleryTemplates.filter(t =>
      DRAFT_RELEVANT_TYPES.indexOf(t.documentType) !== -1 && !installedNames.has(t.name)
    );
    return userThemes.concat(galleryForDrafts);
  }

  getFilteredThemes() {
    let { documentType } = this.props;
    let themes = this.getAllAvailableThemes();
    if (!documentType || documentType === 'any') return themes;
    let mapped = DOC_TYPE_MAP[documentType] || documentType;
    return themes.filter(t => {
      let dt = t.documentType || 'invoice';
      return dt === mapped || dt === 'all';
    });
  }

  render() {
    const { handleSubmit, what, format, user, theme, documentType, created_at_min, created_at_max, initialValues, intl } = this.props;
    const t = (id, values) => intl.formatMessage({ id }, values);
    const show = this.state.show;
    let filteredThemes = this.getFilteredThemes();

    return (
      <Modal backdrop="static" dialogClassName="download-orders-dialog" enforceFocus={true} show={show || false} onHide={this.hide}>
        <form>
          <Modal.Header closeButton>
            <Modal.Title>{t('draftDownload.title')}</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ overflowY: 'visible' }}>
            <p>{t('draftDownload.selectTemplate')}</p>
            <div>
              <Field name="theme" selectedTheme={theme} seller={user} themes={filteredThemes} hideLegacy={true} component={ThemeGallery} />

              {theme && theme.length > 0 && <label>
                <Field name="what" component="input" type="radio" value="all" /> {t('draftDownload.allDraftsBetween')}
              </label>}{"    "}
              {theme && theme.length > 0 && <label>
                <Field name="what" component="input" type="radio" value="selected" /> {t('draftDownload.selectedDrafts')}
              </label>}

              {what === 'all' &&
                <div className="row">
                  <div className="col-md-5">
                    <Field
                      name="created_at_min"
                      component={DateTimeField}
                      validate={[validators.required]}
                      defaultValue={new Date(created_at_min) || new Date(initialValues.created_at_min)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>{" " + t('draftDownload.and') + " "}</label>
                  </div>
                  <div className="col-md-5">
                    <Field
                      name="created_at_max"
                      component={DateTimeField}
                      defaultValue={new Date(created_at_max) || new Date(initialValues.created_at_max)}
                      validate={[validators.required]}
                    />
                  </div>
                </div>}

              {what === 'all' && theme && theme.length > 0 &&
                <div className="row">
                  <br />
                  <div className="col-md-4">
                    <label>{t('draftDownload.status')}</label>{" "}
                    <Field className="form-control" name="status" component="select">
                      <option value="any">{t('draftDownload.any')}</option>
                      <option value="draft">{t('draftDownload.draft')}</option>
                      <option value="sent">{t('draftDownload.sent')}</option>
                      <option value="accepted">{t('draftDownload.accepted')}</option>
                      <option value="expired">{t('draftDownload.expired')}</option>
                      <option value="converted">{t('draftDownload.converted')}</option>
                      <option value="cancelled">{t('draftDownload.cancelled')}</option>
                    </Field>
                  </div>
                  <div className="col-md-4">
                    <label>{t('draftDownload.documentType')}</label>{" "}
                    <Field className="form-control" name="document_type" component="select">
                      <option value="any">{t('draftDownload.any')}</option>
                      <option value="quote">{t('draftDownload.quote')}</option>
                      <option value="proforma">{t('draftDownload.proforma')}</option>
                      <option value="draft_order">{t('draftDownload.draftOrder')}</option>
                      <option value="manual_invoice">{t('draftDownload.manualInvoice')}</option>
                    </Field>
                  </div>
                </div>
              }
              <br />

              {theme && theme.length > 0 && <div className="row">
                <div className="col-md-12">
                  <label>{t('draftDownload.format')}</label>{" "}
                  <label><Field name="format" className="export-as-pdf-radio" component="input" type="radio" value="pdf" />{" "}PDF</label>{" "}
                  {user.profile && canUseFeature(user.profile.subscription, 'bulkExportExcel') && <label><Field name="format" component="input" type="radio" value="xlsx" />{" "}Excel</label>}{" "}
                  {user.profile && canUseFeature(user.profile.subscription, 'ublXml') && <label><Field name="format" component="input" type="radio" value="ublxml" />{" "}Peppol UBL XML / E-Factura</label>}{" "}
                  {user.profile && canUseFeature(user.profile.subscription, 'ublXml') && <label><Field name="format" component="input" type="radio" value="zugferd" />{" "}ZUGFeRD / Factur-X</label>}
                  {user.profile && !canUseFeature(user.profile.subscription, 'ublXml') && <label style={{color:'#999', cursor:'not-allowed'}} title="Upgrade to Starter plan"><span style={{opacity:0.5}}>Peppol UBL XML</span> <span className="label label-info">Starter</span></label>}
                  {user.profile && !canUseFeature(user.profile.subscription, 'bulkExportExcel') && <label style={{color:'#999', cursor:'not-allowed'}} title="Upgrade to a paid plan"><span style={{opacity:0.5}}>Excel / Peppol XML</span> <span className="label label-default">Paid plans</span></label>}
                </div>
              </div>}

              {filteredThemes.length === 0 && <div className="alert alert-info" style={{marginTop: 10}}>
                <i className="fa fa-info-circle"></i>{" "}
                {t('draftDownload.noTemplates')}{documentType && documentType !== 'any' ? ` ${t('draftDownload.noTemplatesForType', { type: documentType })}` : ''}. <a href="/templates">{t('draftDownload.installTemplates')}</a> {t('draftDownload.toStartExporting')}
              </div>}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <small className="pull-left">{t('draftDownload.noteChrome')}</small><br />
            <Button type="button" onClick={this.hide}>{t('draftDownload.cancel')}</Button>
            <Button type="button" onClick={handleSubmit(values => {
              values.individually = true;
              this.props.onOk(values);
            })} disabled={!theme} className="export-download-button" bsStyle="default">{t('draftDownload.downloadIndividually')}</Button>
            <Button type="button" onClick={handleSubmit(values => {
              values.individually = false;
              this.props.onOk(values);
            })} disabled={!theme} className="export-download-button" bsStyle="success">{t('draftDownload.downloadGrouped')}</Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

DownloadDraftsDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired
};

let DownloadDraftsDialogForm = reduxForm({ form: 'DownloadDraftsDialog' })(DownloadDraftsDialog);

const selector = formValueSelector('DownloadDraftsDialog');

DownloadDraftsDialogForm = connect(state => {
  const what = selector(state, 'what');
  const format = selector(state, 'format');
  const theme = selector(state, 'theme');
  const documentType = selector(state, 'document_type');
  const created_at_min = selector(state, 'created_at_min');
  const created_at_max = selector(state, 'created_at_max');
  return {
    what,
    theme,
    format,
    documentType,
    created_at_min,
    created_at_max
  };
}, null, null, {
  withRef: true
})(DownloadDraftsDialogForm);

export default DownloadDraftsDialogForm;



// WEBPACK FOOTER //
// app/components/drafts/DownloadDraftsDialog.jsx